import React, { useState } from "react"
import { Link, useNavigate } from "react-router-dom"
import { useAxios } from "../../hooks/useAxios"
import { useEnter } from "../../hooks/useEnter"
import { FooterError } from "../../ui/errors/FooterError"
import { Loader } from "../../ui/loaders/Loader"
import { FooterSuccess } from "../../ui/success/FooterSuccess"

export const ForgotPassword = () => {
  const api = useAxios()
  const navigate = useNavigate()
  const [email, setEmail] = useState()
  const [loading, setLoading] = useState(false)
  const [errors, setErrors] = useState()
  const [serviceDisabled, setServiceDisabled] = useState("")
  const [success, setSuccess] = useState()
  const forgotPassword = async () => {
    console.log(email)
    setLoading(true)
    setErrors()
    setSuccess()
    try {
      const response = await api.post("forgot-password", { email })
      setSuccess("Password reset information sent to your email address")
    } catch (ex) {
      if (ex?.response?.status === 429) {
        console.log("to many attempt", ex.response.data)
        const er = { attempt: ex?.response?.data?.message }
        setErrors(er)
      } else if (ex?.response?.status === 555) {
        setServiceDisabled("Service disabled!")
      } else {
        setErrors(ex?.response?.data?.errors)
      }
    } finally {
      setLoading(false)
    }
  }
  useEnter(forgotPassword)
  return (
    <div className="position-relative container">
      <div className="w-50 card mx-auto mt-5 shadow">
        <div className="card-header fw-bold ">{process.env.REACT_APP_APP_NAME} Guardian Password Reset</div>
        <div className="card-body">
          <div className="form-group">
            <label className="form-label">Email</label>
            <input type={`text`} className="form-control" onChange={(e) => setEmail(e.target.value)} />
          </div>
        </div>
        <div className="card-footer d-flex align-items-center justify-content-between">
          <div>
            {loading && <Loader message={"Please wait while validating your login details.."} />}
            {errors?.email && <FooterError error={errors?.email} />}
            {serviceDisabled != "" && (
              <div className="text-danger tw-space-x-2 tw-font-bold flex">
                <i className="fa fa-ban"></i>
                <span>{serviceDisabled}</span>
              </div>
            )}
            {errors?.attempt && <FooterError error={errors?.attempt} />}
            {errors && errors["passwords.user"] && <FooterError error={errors["passwords.user"]} />}
            {success && <FooterSuccess success={success} />}
          </div>

          <div className="tw-flex ">
            <button onClick={() => navigate("/login")} className="btn btn-default">
              Back to login
            </button>
            <button onClick={forgotPassword} className="btn btn-primary">
              Reset Password
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}
